<div class="carousel-section">
  <!-- Slide -->
  <div class="carousel-slide">
    <div class="card-image-wrapper">
      <img class="card-img" [alt]="features[currentIndex].title" [src]="features[currentIndex].image" />
    </div>
  </div>

  <!-- Controls -->
  <div class="carousel-controls">
    <button class="nav-btn" aria-label="Previous" [disabled]="currentIndex === 0" (click)="prev()">
      <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 3L5 8L10 13"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </svg>
    </button>

    <div class="dots">
      <span
        class="dot"
        *ngFor="let item of features; let i = index"
        [class.active]="i === currentIndex"
        (click)="goTo(i)"
      ></span>
    </div>

    <button class="nav-btn" aria-label="Next" [disabled]="currentIndex === features.length - 1" (click)="next()">
      <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 3L11 8L6 13"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </svg>
    </button>
  </div>
</div>
